import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import Icon from "react-icons-kit";
import { androidClose } from "react-icons-kit/ionicons/androidClose";
import AlertBox from "../../../common/UI/AlertBox/AlertBox";
import "../../../../assets/css/components/Modal/Modal.css";
import "../../../../assets/css/components/Profile/MemberComponent/Invite/Invite.css";
import ApiCalls from "../../../apis/api-calls";
import Utility from "../../../../common/utility";

const formData = {
  email: {
    value: "",
    error: "",
    errMsg: "",
  },
  role: {
    value: "",
    error: "",
    errMsg: "",
  },
}

const InviteComponent = inject("sharedStore")(
  observer((props) => {
    const {
      modalVisibility,
      modalLabel,
      closeModalHandler,
      modalClass,
      switchModal,
      sharedStore,

    } = props;
    const [form, setForm] = useState(formData);

    const closeModal = () => {
      clearState()
      closeModalHandler()
    }

    const onInputChange = (e) => {
      form[e.target.name].value = e.target.value
      form[e.target.name].error = false
      form[e.target.name].errMsg = ""
      setForm({ ...form });
    };


    const clearState = () => {
      form.email.value = ""
      form.email.errMsg = ""
      form.email.error = false
      form.role.value = ""
      form.role.errMsg = ""
      form.role.error = false
      setForm({ ...form });
    };

    const handleValidation = () => {
      let formIsValid = true;
      if (!form.email.value) {
        formIsValid = false;
        form.email.value = ""
        form.email.error = true
        form.email.errMsg = "Email cannot be empty"
      }
      if (!form.role.value) {
        formIsValid = false;
        form.role.value = ""
        form.role.error = true
        form.role.errMsg = "Role cannot be empty!"
      }
      setForm({ ...form });
      return formIsValid;
    };
    const validateEmail = () => {
      let formIsValid = true;
      if (!form.email.value) {
        formIsValid = false;
        form.email.value = ""
        form.email.error = true
        form.email.errMsg = "Email cannot be empty"
      }
      setForm({ ...form });
      return formIsValid;
    };
    const handleSubmit = (e) => {
      e.preventDefault();
      const { role, email } = form;
      if (handleValidation()) {
        if (validateEmail()) {
          let errMsg = "";
          sharedStore.showLoader();
          let data = {
            roleId: role.value,
            email: email.value,
          };
          ApiCalls.sendInvitation(data).then((response) => {
            sharedStore.hideLoader();
            if (response) {
              clearState()
              if (response.error === false) {
                ApiCalls.getMemberInfo().then((response) => {
                  sharedStore.hideLoader();
                  if (response && response.error === false) {
                    sharedStore.setMembersData(response.data);
                  }
                });
                switchModal(2);
              } else {
                errMsg = response.message;
                switchModal(3, errMsg);
              }
            }
          });
          closeModalHandler();
        }
      }
    };

    const checkEmail = () => {
      let isValidEmail = Utility.isValidEmail(form.email.value);
      if (isValidEmail) {
        sharedStore.showLoader();
        ApiCalls.isExistingMember({ email: form.email.value }).then((res) => {
          sharedStore.hideLoader();
          if (res && res.error === true) {
            form.email.error = true
            form.email.errMsg = res.message
            setForm({ ...form });
          }
        });
      } else {
        form.email.error = true
        form.email.errMsg = "Invalid Email"
        setForm({ ...form });
      }
    };
    return (
      <AlertBox
        alertVisibility={modalVisibility}
        closeAlertBoxHandler={closeModalHandler}
        backdrop={true}
        alertLabel={modalLabel}
        alertClass={modalClass}
      >
        <div className="modal-wrapper">
          <div className="modal-header">
            <h3>Invite Members</h3>
            <span onClick={closeModal} className="close-icon-wrapper">
              <Icon size={24} icon={androidClose} className="cursor-pointer" />
            </span>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="field-wrapper">
                <div
                  className={
                    form.email && form.email.error ? "form-group error-wrapper" : "form-group"
                  }
                >
                  <label htmlFor="e-mail">Email *</label>
                  <input
                    type="text"
                    maxLength="50"
                    autoComplete="off"
                    className="form-control"
                    name="email"
                    id="e-mail"
                    value={form && form.email ? form.email.value : ""}
                    placeholder="john.doe@gmail.com"
                    onChange={(e) => onInputChange(e)}
                    onBlur={checkEmail}
                  />
                  {form.email && form.email.error ? (
                    <span className={"text-danger text-sm"}>
                      {" "}
                      {form.email.errMsg}
                    </span>
                  ) : (
                      ""
                    )}
                </div>
                <div
                  className={
                    form.role && form.role.error ? "form-group error-wrapper" : "form-group"
                  }
                >
                  <label htmlFor="rle">Role *</label>
                  <select
                    className={
                      form.role && !form.role.value
                        ? "form-control selection"
                        : "form-control"
                    }
                    name="role"
                    id="rle"
                    value={form && form.role ? form.role.value : ""}
                    onChange={(e) => onInputChange(e)}
                  >
                    <option disable={true} hidden value="">
                      Assign Role
                    </option>
                    <option value="1">Admin</option>
                    <option value="2">Developer</option>
                    <option value="3">Report Creator</option>
                  </select>
                  {form.role && form.role.error ? (
                    <span className={"text-danger text-sm"}>
                      {" "}
                      {form.role.errMsg}
                    </span>
                  ) : (
                      ""
                    )}
                </div>
              </div>
              <div className="text-center">
                <button type="submit" className="btn btn-common">
                  Send Invite
                </button>
              </div>
            </form>
          </div>
        </div>
      </AlertBox>
    );
  })
);
export default InviteComponent;


// WEBPACK FOOTER //
// ./src/components/Profile/MemberComponent/Invite/InviteComponent.jsx